import { render, staticRenderFns } from "./WikiPageTemplateList.vue?vue&type=template&id=2c9e9be2&scoped=true"
import script from "./WikiPageTemplateList.vue?vue&type=script&lang=ts"
export * from "./WikiPageTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageTemplateList.vue?vue&type=style&index=0&id=2c9e9be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e9be2",
  null
  
)

export default component.exports